import {
  GET_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  UPDATE_NOTIFICATIONS,
  UPDATE_ALL_NOTIFICATIONS,
  DELETE_NOTIFY
} from "./actionTypes";

export const getNotifications = () => ({
  type: GET_NOTIFICATIONS,
});

export const setNotifications = (data) => ({
  type: SET_NOTIFICATIONS,
  payload: data
});

export const updateNotifications = (data) => ({
  type: UPDATE_NOTIFICATIONS,
  payload: data
});

export const updateAllNotifications = () => ({
  type: UPDATE_ALL_NOTIFICATIONS,
});

export const deleteNotification = (id) => ({
  type: DELETE_NOTIFY,
  payload: id
})